const dayforceKey = ['dayforce'] as const

export const dayforceKeys = {
  all: dayforceKey,
  agencies: () => [...dayforceKey, 'agencies'] as const,
  bookings: () => [...dayforceKey, 'bookings'] as const,
  bookingsList: (params: {
    page: number
    pageSize: number
    agencyId?: string[] | null
  }) =>
    [
      ...dayforceKeys.bookings(),
      params.page,
      params.pageSize,
      params.agencyId,
    ] as const,
  jobDetail: (agencyId: string, jobId: string) =>
    [...dayforceKey, 'job', agencyId, jobId] as const,
  webhooks: () => [...dayforceKey, 'webhooks'] as const,
  webhooksList: (params: {
    page: number
    pageSize: number
    agencyId?: string[] | null
    eventType?: string[] | null
    status?: string[] | null
  }) =>
    [
      ...dayforceKeys.webhooks(),
      params.page,
      params.pageSize,
      params.agencyId,
      params.eventType,
      params.status,
    ] as const,
  webhookDetail: (webhookId: number) =>
    [...dayforceKey, 'webhook', webhookId] as const,
  jobsIssues: () => [...dayforceKey, 'jobsIssues'] as const,
  jobsIssuesList: (params: {
    page: number
    pageSize: number
    agencyId?: string[] | null
  }) =>
    [
      ...dayforceKeys.jobsIssues(),
      params.page,
      params.pageSize,
      params.agencyId,
    ] as const,
}
